import React from "react";

export type BenefitCardProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
};

export type BenefitItem = {
  readonly Icon: React.FC<{ className?: string }>;
  readonly title: string;
  readonly description: string;
};

export const BenefitCard: React.FC<BenefitCardProps> = ({
  icon,
  title,
  description,
}) => (
  <div className="flex flex-col gap-4 rounded-2xl bg-white p-6">
    <div className="bg-primary-50 text-primary-500 flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-[20px]">
      {icon}
    </div>
    <h3 className="subtitle-b-bold text-black">{title}</h3>
    <p className="body-b-regular text-black">{description}</p>
  </div>
);
